export default __webpack_public_path__ + "static/media/think2.b3b3e7df.png";